import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconWarning';
/** Renders an SVG icon. */
const SvgWarning = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.91 4.6a1.018 1.018 0 0 0-1.82 0L5.147 24.489a1.018 1.018 0 0 0 .91 1.474h19.884c.756 0 1.249-.797.91-1.474L16.911 4.6Zm-3.642-.911c1.126-2.252 4.338-2.252 5.464 0l9.942 19.89c1.015 2.03-.462 4.421-2.732 4.421H6.058c-2.27 0-3.747-2.39-2.732-4.422L13.268 3.69Z"
      />
      <path fill="currentColor" d="M17 23a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      <path fill="currentColor" fillRule="evenodd" d="M16 12a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1" />
    </svg>
  );
};
SvgWarning.displayName = displayName;
export default SvgWarning;
